import { render, staticRenderFns } from "./auxiliaryResources.vue?vue&type=template&id=487668e1"
import script from "./auxiliaryResources.vue?vue&type=script&lang=js"
export * from "./auxiliaryResources.vue?vue&type=script&lang=js"
import style0 from "./auxiliaryResources.vue?vue&type=style&index=0&id=487668e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports